"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const ScrollFix = () => {
  const pathname = usePathname();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";

      const restoreScroll = () => {
        const savedY = sessionStorage.getItem(`scroll-${pathname}`);
        if (savedY) {
          // kasih delay biar DOM siap
          setTimeout(() => {
            window.scrollTo({
              top: parseInt(savedY),
              behavior: "smooth" // scroll halus
            });
          }, 200); // delay 200ms, bisa kamu sesuaikan
        }
      };

      const saveScroll = () => {
        sessionStorage.setItem(`scroll-${pathname}`, String(window.scrollY));
      };

      window.addEventListener("beforeunload", saveScroll);
      window.addEventListener("unload", saveScroll);
      window.addEventListener("scroll", saveScroll);

      restoreScroll();

      return () => {
        window.removeEventListener("beforeunload", saveScroll);
        window.removeEventListener("unload", saveScroll);
        window.removeEventListener("scroll", saveScroll);
      };
    }
  }, [pathname]);

  return null;
};

export default ScrollFix;
